var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Box, CheckBox } from 'grommet';
import { Moon, Sun } from 'grommet-icons';
import { ThemeModeContext } from './ThemeProvider';
export var ThemeModeToggle = function () {
    var _a = useContext(ThemeModeContext), mode = _a.mode, toggleMode = _a.toggleMode;
    return (_jsx(CheckBox, __assign({ checked: mode === "dark", onChange: toggleMode }, { children: function (_a) {
            var checked = _a.checked;
            return (_jsxs(Box, __assign({ background: checked ? "background-contrast" : "white", pad: { horizontal: "small", vertical: "xsmall" }, gap: "xsmall", round: "medium", border: checked ? undefined : { color: "light-4", size: "small" }, direction: "row", align: "center" }, { children: [_jsx(Box, { round: "full", border: {
                            color: checked ? "dark-4" : "status-warning",
                            size: "3px",
                        }, width: "20px", height: "20px" }), checked ? _jsx(Moon, { color: "light-1" }) : _jsx(Sun, { color: "dark-1" })] })));
        } })));
};
//# sourceMappingURL=ThemeModeToggle.js.map